import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/Layout/index.js";
import { Link } from "gatsby";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { Flex, Box } from "theme-ui";
import Wide from "../components-styled/Wide";
import PictureSet from "../components/PictureSet";
import imgSet11 from "../imgsets/imgset11";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEO title="Impressum" mdxType="SEO" />
    <Wide mdxType="Wide">
      <PictureSet imgSet={imgSet11} mdxType="PictureSet" />
    </Wide>
    <h2>{`Impressum`}</h2>
    <h4>{`Pflichtangaben nach dem Teledienstgesetz:`}</h4>
    <p>{`Der hochschulgründernetz cologne e.V. ist ein Verein bestehend aus neunzehn Mitgliedsinstitutionen.`}</p>
    <p>{`Die Geschäftsführung liegt seit dem 01.04.2018 bei der CBS International Business School.`}</p>
    <p><strong parentName="p">{`Anschrift:`}</strong><br />{`
hochschulgründernetz cologne e.V.`}<br />{`
c/o CBS International Business School`}<br />{`
Hardefuststr. 1`}<br />{`
50677 Köln`}<br />{`
Telefon: +49 (0)221 / 931809-843`}<br />{`
E-Mail: `}<a parentName="p" {...{
        "href": "mailto:hgnc@hgnc.de",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`hgnc@hgnc.de`}</a><br />{`
Webseite: hgnc.de`}<br /></p>
    <p><strong parentName="p">{`Vorstand:`}</strong><br />{`
Prof. Dr. Klaus Becker (Vorsitzender)`}<br />{`
Prof. Dr. Rainer Minz (stellv. Vorsitzender)`}<br />{`
Prof. Dr. Sebastian Uhrich (Schatzmeister)`}<br />{`
Verena Wagner`}<br />{`
Prof. Dr. Kai Thierhoff`}<br /></p>
    <p><strong parentName="p">{`Geschäftsführung:`}</strong><br />{`
Prof. Dr. Ulrich Anders`}<br /></p>
    <p><strong parentName="p">{`Rechtsform:`}</strong><br />{`
Der hochschulgründernetz cologne e.V. ist ein gemeinnütziger Verein mit dem Ziel, Existenzgründungen aus der Hochschule zu fördern.`}</p>
    <p><strong parentName="p">{`Registergericht und Registernummer:`}</strong><br />{`
Der hochschulgründernetz cologne e.V. ist beim Amtsgericht Köln im Vereinsregister unter der Nummer VR 17370 eingetragen.`}</p>
    <p><strong parentName="p">{`Steuernummer:`}</strong><br />{`
223/5908/0647`}<br />{`
gemäß § 27a Umsatzsteuergesetz`}</p>
    <h4>{`Haftung für Inhalte`}</h4>
    <p>{`Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.`}</p>
    <p>{`Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.`}</p>
    <p>{`Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.`}</p>
    <h4>{`Haftung für Links`}</h4>
    <p>{`Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.`}</p>
    <p>{`Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.`}</p>
    <h4>{`Urheberrecht`}</h4>
    <p>{`Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.`}</p>
    <p>{`Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.`}</p>
    <p>{`Quellverweis: `}<a parentName="p" {...{
        "href": "https://www.e-recht24.de",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`e-recht24.de`}</a></p>
    <h4>{`Bilder & Grafiken`}</h4>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      